/**
 * Runtime configuration — written by infra/scripts/write-config.mjs.
 * Fetched before app boot so infra value changes never require a rebuild.
 */
export interface AppConfig {
  /** '/api' in production (same origin via CloudFront); absolute URL in local dev */
  apiBase: string;
  /** Cognito OIDC issuer, e.g. https://cognito-idp.us-east-1.amazonaws.com/<poolId> */
  issuer: string;
  clientId: string;
  /** Managed login base, e.g. https://auth.forms.knocking.com */
  hostedUiBase: string;
}

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Could not load app config (HTTP ${res.status})`);
  const cfg = (await res.json()) as AppConfig;
  if (!cfg.apiBase || !cfg.issuer || !cfg.clientId || !cfg.hostedUiBase) {
    throw new Error('App config is incomplete');
  }
  return cfg;
}
